import { getIsUnplannedReactiveScope } from 'pages/WellGuardian/WIR/utils';
import { WIRCreateJourneyStepsKeys } from 'pages/WellGuardian/WIR/wir.constants';
import { WIR } from 'types/wellGuardian';

import { getEngineeringWorkSectionKey } from './getSectionData';

export const getEngineeringWorkReactiveScopeData = (wir: WIR | null, countrySelect: string) => {
  const phase = getIsUnplannedReactiveScope(wir)
    ? WIRCreateJourneyStepsKeys.REACTIVE_SCOPE
    : getEngineeringWorkSectionKey(countrySelect);
  const equipmentIdentification = wir?.phases?.[phase]?.sections?.equipmentIdentification;
  const engineeringAnalysis = wir?.phases?.[phase]?.sections?.engineeringAnalysis;

  return {
    phase,
    equipmentIdentification,
    engineeringAnalysis,
  };
};
